/**
 * GET TS TO HOURS
 * @param {Number} ts date as timestamp in second (like python TS)
 * @return {Number} Human readable hours
 */

export default {
  methods: {
    getTsToHours(ts) {
      const hours = new Date(ts * 1000).getHours();
      return hours;
    },
  },
};
